import { saveConfiguration } from "@/lib/catalog-api";
import { useConfiguration } from "./useConfiguration";
import { saveErrorMessage } from "../lib/saveMessage";
import { useToast } from "./useToast";

/**
 * Empty "Use the path from earlier" keeps the saved default path.
 * It does not switch the default to the path open in the wizard.
 */
export function useSaveDefaults() {
  const {
    wakePhrase,
    wakeOnnx,
    voiceAgentId,
    webhookSecret,
    updateWebhook,
    defaultPolicyId,
    configEnabled,
    baselineDefaultPolicyId,
    setSaving,
    commitSavedDefaults,
  } = useConfiguration();
  const toast = useToast();

  const save = async () => {
    const savedDefaultPolicyId =
      defaultPolicyId === ""
        ? baselineDefaultPolicyId
        : Number(defaultPolicyId);
    const snapshot = {
      wakePhrase: wakePhrase.trim() || "Hey Sentara",
      wakeOnnx: wakeOnnx.trim(),
      voiceAgentId: voiceAgentId.trim(),
      webhookSecret: "",
      updateWebhook: false,
      defaultPolicyId:
        savedDefaultPolicyId == null ? ("" as const) : savedDefaultPolicyId,
      configEnabled,
    };

    setSaving(true);
    try {
      const result = await saveConfiguration({
        wakePhrase: snapshot.wakePhrase,
        wakeWordOnnxPath: snapshot.wakeOnnx || null,
        voiceAgentId: snapshot.voiceAgentId || null,
        voiceAgentWebhookSecret: updateWebhook ? webhookSecret : null,
        updateWebhookSecret: updateWebhook,
        defaultEscalationPolicyId: savedDefaultPolicyId,
        isEnabled: configEnabled,
      });
      if (!result.ok) {
        toast.error(saveErrorMessage(result.message));
        return;
      }
      commitSavedDefaults(snapshot, savedDefaultPolicyId, updateWebhook);
      toast.success("Defaults saved.");
    } catch (error) {
      toast.error(saveErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  return { save };
}
